import Enums from "@/enums/enums";

export const CompareAmount = (paymentTransactionList = [], bankStatementList = []) => {
  let amountPaymentTransaction = 0;
  let amountBankStatement = 0;
  if (paymentTransactionList && paymentTransactionList.length > 0) {
    for (const paymentTransaction of paymentTransactionList) {
      amountPaymentTransaction += paymentTransaction.paymentTotal.ToNumber();
    }
  }

  if (bankStatementList && bankStatementList.length > 0) {
    for (const bankStatement of bankStatementList) {
      amountBankStatement += bankStatement.paymentTotal.ToNumber();
    }
  }

  amountPaymentTransaction = amountPaymentTransaction.ToAccountingRoundUp();
  amountBankStatement = amountBankStatement.ToAccountingRoundUp();

  const diffAmount = amountPaymentTransaction - amountBankStatement;

  return {
    amountPaymentTransaction: amountPaymentTransaction,
    amountBankStatement: amountBankStatement,
    diffAmount: diffAmount,
    isEqualAmount: amountPaymentTransaction === amountBankStatement,
  };
};

export const GetKeyForPaymentDateAndPaymentTotal = (paymentDate, paymentTotal) => {
  return `${paymentDate ? new Date(paymentDate).ToDateJsonString() : ""}:${
    paymentTotal ? paymentTotal.ToNumber() : ""
  }`;
};

export const ConvertPaymentTransactionListToMap = (paymentTransactionList) => {
  const paymentTransactionMap = new Map();
  if (paymentTransactionList && paymentTransactionList.length > 0) {
    for (const paymentTransaction of paymentTransactionList) {
      const key = GetKeyForPaymentDateAndPaymentTotal(paymentTransaction.paymentDate, paymentTransaction.paymentTotal);

      if (paymentTransactionMap.has(key)) {
        const paymentTransactionIdList = paymentTransactionMap.get(key);
        paymentTransactionIdList.push(paymentTransaction.id);
        paymentTransactionMap.set(key, paymentTransactionIdList);
      } else {
        paymentTransactionMap.set(key, [paymentTransaction.id]);
      }
    }
  }
  return paymentTransactionMap;
};

export const GetPaymentTransactionIdFromPaymentTransactionMap = (paymentTransactionMap, key) => {
  let paymentTransactionId = 0;
  if (paymentTransactionMap.has(key)) {
    paymentTransactionId = paymentTransactionMap.get(key)[0];
    RemovePaymentTransactionIdFromValuePaymentTransactionMap(paymentTransactionMap, key, paymentTransactionId);
  }
  return paymentTransactionId;
};

export const RemovePaymentTransactionIdFromValuePaymentTransactionMap = (
  paymentTransactionMap,
  key,
  paymentTransactionId
) => {
  if (paymentTransactionMap.has(key)) {
    const paymentTransactionIdList = paymentTransactionMap.get(key);
    const index = paymentTransactionIdList.indexOf(paymentTransactionId);
    if (index > -1) {
      paymentTransactionIdList.splice(index, 1);
      paymentTransactionMap.set(key, paymentTransactionIdList);
    }
  }
};

export const GroupingBySameAmountButDiffDate = (paymentBankStatement, paymentTransactionMap, numberOfDiffDate) => {
  const reconcile = {
    paymentTransactionId: 0,
    paymentBankStatementId: 0,
  };
  let key = "";

  const paymentTotal = paymentBankStatement.paymentTotal.ToNumber();
  let paymentDate = null;
  if (numberOfDiffDate == 0) {
    paymentDate = new Date(paymentBankStatement.paymentDate);
    key = GetKeyForPaymentDateAndPaymentTotal(paymentDate, paymentTotal);
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    }
  } else {
    paymentDate = new Date(paymentBankStatement.paymentDate);
    key = GetKeyForPaymentDateAndPaymentTotal(
      paymentDate.setDate(paymentDate.getDate() + numberOfDiffDate),
      paymentTotal
    );
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    } else {
      const addDate = numberOfDiffDate * -1;
      paymentDate = new Date(paymentBankStatement.paymentDate);
      key = GetKeyForPaymentDateAndPaymentTotal(paymentDate.setDate(paymentDate.getDate() + addDate), paymentTotal);
      if (paymentTransactionMap.has(key)) {
        reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
      }
    }
  }

  if (reconcile.paymentTransactionId > 0) {
    paymentBankStatement.isGrouping = true;
    reconcile.paymentBankStatementId = paymentBankStatement.id;
  }
  return reconcile;
};

export const GroupingReconcileList = (paymentBankStatementList, paymentTransactionList) => {
  const reconcileList = [];
  let paymentBankStatementMockList = [];

  for (const paymentBankStatement of paymentBankStatementList) {
    paymentBankStatementMockList.push({ ...paymentBankStatement, isGrouping: false });
  }

  const paymentTransactionMap = ConvertPaymentTransactionListToMap(paymentTransactionList);
  const numberOfDiffDate = 3;
  for (let i = 0; i <= numberOfDiffDate; i++) {
    for (const paymentBankStatementMock of paymentBankStatementMockList) {
      const reconcile = GroupingBySameAmountButDiffDate(paymentBankStatementMock, paymentTransactionMap, i);
      if (reconcile.paymentTransactionId > 0 && reconcile.paymentBankStatementId > 0) {
        reconcileList.push(reconcile);
      }
    }
    paymentBankStatementMockList = paymentBankStatementMockList.filter(
      (paymentBankStatement) => paymentBankStatement.isGrouping === false
    );
  }
  return reconcileList;
};

export const ExtractBankDetailsFromRemark = (remark, bankReferenceBankId) => {
  const bankRegexArray = [
    {
      bankReferenceBankId: Enums.BankReferenceType.KBANK,
      regex:
        /(จาก|โอนไป)\s*(([A-Z]+\s*)+)?X\d{4}\s*(น\.ส\.|นางสาว|นาย|นาง|Mr\.|Mrs\.|Ms\.|บริษัท|บจ\.)?\s*([ก-๙A-Za-z\s\-]+)(?:\s*\+\+)?/,
    },
    {
      bankReferenceBankId: Enums.BankReferenceType.SCB,
      regex:
        /(รับโอนจาก|รับเงินจาก|Transfer to|จาก|โอนไป)\s*(([A-Z]+)\s*[xX]\d{4})\s*(น\.ส\.|นางสาว|นาย|นาง|Mr\.|Mrs\.|Ms\.|MRS\.|บริษัท|บจ\.)?\s*([ก-๙A-Za-z\s\-]+)(?:\s*\+\+)?/,
    },
  ];

  const selectedBank = bankRegexArray.find((bank) => bank.bankReferenceBankId === bankReferenceBankId);

  if (!selectedBank) {
    return {
      transactionDirection: "",
      bankname: "",
      bankaccount: "",
      honorific: "",
      bankaccountname: "",
    };
  }

  const { regex } = selectedBank;
  const match = remark.match(regex);

  if (match) {
    if (bankReferenceBankId === Enums.BankReferenceType.KBANK) {
      return {
        transactionDirection: match[1] || "", // "จาก" or "โอนไป"
        bankname: match[2] ? match[2].trim() : "", // Bank name, if present
        bankaccount: match[0].match(/X\d{4}/)[0], // Extract "X1234"
        honorific: match[4] || "", // Thai or English title
        bankaccountname: match[5] ? match[5].trim() : "", // Full name (Thai or English)
      };
    } else if (bankReferenceBankId === Enums.BankReferenceType.SCB) {
      const accountMaskMatch = match[2].match(/[xX]\d{4}/);
      const bankNameMatch = match[2].match(/[A-Z]+/);
      return {
        transactionDirection: match[1] || "", // "จาก" or "โอนไป"
        bankname: bankNameMatch ? bankNameMatch[0] : "", // Bank name, if present
        bankaccount: accountMaskMatch ? accountMaskMatch[0] : "", // Extract "X1234"
        honorific: match[4] || "", // Thai or English title
        bankaccountname: match[5] ? match[5].trim() : "", // Full name (Thai or English)
      };
    } else {
      return {
        transactionDirection: match[1] || "", // "จาก" or "โอนไป"
        bankname: bankNameMatch ? bankNameMatch[0] : "", // Bank name, if present
        bankaccount: accountMaskMatch ? accountMaskMatch[0] : "", // Extract "X1234"
        honorific: match[4] || "", // Thai or English title
        bankaccountname: match[5] ? match[5].trim() : "", // Full name (Thai or English)
      };
    }
  }

  return {
    transactionDirection: "",
    bankname: "",
    bankaccount: "",
    honorific: "",
    bankaccountname: "",
  };
};

export const GroupingBySameAmountButDiffDateWithRemark = (
  paymentBankStatement,
  paymentTransactionMap,
  numberOfDiffDate,
  bankReferenceBankId
) => {
  const reconcile = {
    paymentTransactionId: 0,
    paymentBankStatementId: 0,
  };
  let key = "";

  const paymentTotal = paymentBankStatement.paymentTotal.ToNumber();
  const paymentDate = new Date(paymentBankStatement.paymentDate);

  const bankDetails = ExtractBankDetailsFromRemark(paymentBankStatement.remark, bankReferenceBankId);

  if (numberOfDiffDate == 0) {
    key = GetKeyForReconciliation(paymentDate, paymentTotal, bankDetails);
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    }
  } else {
    key = GetKeyForReconciliation(
      paymentDate.setDate(paymentDate.getDate() + numberOfDiffDate),
      paymentTotal,
      bankDetails
    );
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    } else {
      const addDate = numberOfDiffDate * -1;
      key = GetKeyForReconciliation(paymentDate.setDate(paymentDate.getDate() + addDate), paymentTotal, bankDetails);
      if (paymentTransactionMap.has(key)) {
        reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
      }
    }
  }

  if (reconcile.paymentTransactionId > 0) {
    paymentBankStatement.isGrouping = true;
    reconcile.paymentBankStatementId = paymentBankStatement.id;
  }
  return reconcile;
};

export const GroupingBySameAmountButDiffDateWithRemarkRelaxBankAccountName = (
  paymentBankStatement,
  paymentTransactionMap,
  numberOfDiffDate,
  bankReferenceBankId
) => {
  const reconcile = {
    paymentTransactionId: 0,
    paymentBankStatementId: 0,
  };
  let key = "";

  const paymentTotal = paymentBankStatement.paymentTotal.ToNumber();
  const paymentDate = new Date(paymentBankStatement.paymentDate);

  const bankDetails = ExtractBankDetailsFromRemark(paymentBankStatement.remark, bankReferenceBankId);

  if (numberOfDiffDate == 0) {
    key = GetKeyForReconciliationRelaxBankAccountName(paymentDate, paymentTotal, bankDetails);
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    }
  } else {
    key = GetKeyForReconciliationRelaxBankAccountName(
      paymentDate.setDate(paymentDate.getDate() + numberOfDiffDate),
      paymentTotal,
      bankDetails
    );
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    } else {
      const addDate = numberOfDiffDate * -1;
      key = GetKeyForReconciliationRelaxBankAccountName(
        paymentDate.setDate(paymentDate.getDate() + addDate),
        paymentTotal,
        bankDetails
      );
      if (paymentTransactionMap.has(key)) {
        reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
      }
    }
  }

  if (reconcile.paymentTransactionId > 0) {
    paymentBankStatement.isGrouping = true;
    reconcile.paymentBankStatementId = paymentBankStatement.id;
  }
  return reconcile;
};

export const GroupingBySameAmountButDiffDateWithRemarkToContactName = (
  paymentBankStatement,
  paymentTransactionMap,
  numberOfDiffDate,
  bankReferenceBankId
) => {
  const reconcile = {
    paymentTransactionId: 0,
    paymentBankStatementId: 0,
  };
  let key = "";

  const paymentTotal = paymentBankStatement.paymentTotal.ToNumber();
  const paymentDate = new Date(paymentBankStatement.paymentDate);

  const bankDetails = ExtractBankDetailsFromRemark(paymentBankStatement.remark, bankReferenceBankId);

  if (numberOfDiffDate == 0) {
    key = GetKeyForReconciliationToContactName(paymentDate, paymentTotal, bankDetails);
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    }
  } else {
    key = GetKeyForReconciliationToContactName(
      paymentDate.setDate(paymentDate.getDate() + numberOfDiffDate),
      paymentTotal,
      bankDetails
    );
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    } else {
      const addDate = numberOfDiffDate * -1;
      key = GetKeyForReconciliationToContactName(
        paymentDate.setDate(paymentDate.getDate() + addDate),
        paymentTotal,
        bankDetails
      );
      if (paymentTransactionMap.has(key)) {
        reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
      }
    }
  }

  if (reconcile.paymentTransactionId > 0) {
    paymentBankStatement.isGrouping = true;
    reconcile.paymentBankStatementId = paymentBankStatement.id;
  }
  return reconcile;
};

export const GroupingBySameAmountButDiffDateWithRemarkAndContactName = (
  paymentBankStatement,
  paymentTransactionMap,
  numberOfDiffDate,
  bankReferenceBankId
) => {
  const reconcile = {
    paymentTransactionId: 0,
    paymentBankStatementId: 0,
  };
  let key = "";

  const paymentTotal = paymentBankStatement.paymentTotal.ToNumber();
  const paymentDate = new Date(paymentBankStatement.paymentDate);

  const bankDetails = ExtractBankDetailsFromRemark(paymentBankStatement.remark, bankReferenceBankId);

  if (numberOfDiffDate == 0) {
    key = GetKeyForReconciliationWithRemarkAndContactName(paymentDate, paymentTotal, bankDetails);
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    }
  } else {
    key = GetKeyForReconciliationWithRemarkAndContactName(
      paymentDate.setDate(paymentDate.getDate() + numberOfDiffDate),
      paymentTotal,
      bankDetails
    );
    if (paymentTransactionMap.has(key)) {
      reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
    } else {
      const addDate = numberOfDiffDate * -1;
      key = GetKeyForReconciliationWithRemarkAndContactName(
        paymentDate.setDate(paymentDate.getDate() + addDate),
        paymentTotal,
        bankDetails
      );
      if (paymentTransactionMap.has(key)) {
        reconcile.paymentTransactionId = GetPaymentTransactionIdFromPaymentTransactionMap(paymentTransactionMap, key);
      }
    }
  }

  if (reconcile.paymentTransactionId > 0) {
    paymentBankStatement.isGrouping = true;
    reconcile.paymentBankStatementId = paymentBankStatement.id;
  }
  return reconcile;
};

export const GroupingReconcileListWithRemark = (
  paymentBankStatementList,
  paymentTransactionList,
  bankReferenceBankId
) => {
  const reconcileList = [];
  let paymentBankStatementMockList = [...paymentBankStatementList];
  const paymentTransactionMap = ConvertPaymentTransactionListToMapWithRemark(paymentTransactionList);
  const numberOfDiffDate = 3;
  for (let i = 0; i <= numberOfDiffDate; i++) {
    for (const paymentBankStatementMock of paymentBankStatementMockList) {
      const reconcile = GroupingBySameAmountButDiffDateWithRemark(
        paymentBankStatementMock,
        paymentTransactionMap,
        i,
        bankReferenceBankId
      );
      if (reconcile.paymentTransactionId > 0 && reconcile.paymentBankStatementId > 0) {
        reconcileList.push(reconcile);
      }
    }
    paymentBankStatementMockList = paymentBankStatementMockList.filter(
      (paymentBankStatement) => paymentBankStatement.isGrouping === false
    );
  }
  return reconcileList;
};

export const GroupingReconcileListWithRemarkRelaxBankAccountName = (
  paymentBankStatementList,
  paymentTransactionList,
  bankReferenceBankId
) => {
  const reconcileList = [];
  let paymentBankStatementMockList = [...paymentBankStatementList];
  const paymentTransactionMap =
    ConvertPaymentTransactionListToMapWithRemarkRelaxBankAccountName(paymentTransactionList);

  const numberOfDiffDate = 3;
  for (let i = 0; i <= numberOfDiffDate; i++) {
    for (const paymentBankStatementMock of paymentBankStatementMockList) {
      const reconcile = GroupingBySameAmountButDiffDateWithRemarkRelaxBankAccountName(
        paymentBankStatementMock,
        paymentTransactionMap,
        i,
        bankReferenceBankId
      );
      if (reconcile.paymentTransactionId > 0 && reconcile.paymentBankStatementId > 0) {
        reconcileList.push(reconcile);
      }
    }
    paymentBankStatementMockList = paymentBankStatementMockList.filter(
      (paymentBankStatement) => paymentBankStatement.isGrouping === false
    );
  }
  return reconcileList;
};

export const GroupingReconcileListWithRemarkToContactName = (
  paymentBankStatementList,
  paymentTransactionList,
  bankReferenceBankId
) => {
  const reconcileList = [];
  let paymentBankStatementMockList = [...paymentBankStatementList];
  const paymentTransactionMap = ConvertPaymentTransactionListToMapWithRemarkToContactName(paymentTransactionList);

  const numberOfDiffDate = 3;
  for (let i = 0; i <= numberOfDiffDate; i++) {
    for (const paymentBankStatementMock of paymentBankStatementMockList) {
      const reconcile = GroupingBySameAmountButDiffDateWithRemarkToContactName(
        paymentBankStatementMock,
        paymentTransactionMap,
        i,
        bankReferenceBankId
      );
      if (reconcile.paymentTransactionId > 0 && reconcile.paymentBankStatementId > 0) {
        reconcileList.push(reconcile);
      }
    }
    paymentBankStatementMockList = paymentBankStatementMockList.filter(
      (paymentBankStatement) => paymentBankStatement.isGrouping === false
    );
  }
  return reconcileList;
};

export const GroupingReconcileListWithRemarkAndContactName = (
  paymentBankStatementList,
  paymentTransactionList,
  bankReferenceBankId
) => {
  const reconcileList = [];
  let paymentBankStatementMockList = [...paymentBankStatementList];
  const paymentTransactionMap = ConvertPaymentTransactionListToMapWithRemarkAndContactName(paymentTransactionList);

  const numberOfDiffDate = 3;
  for (let i = 0; i <= numberOfDiffDate; i++) {
    for (const paymentBankStatementMock of paymentBankStatementMockList) {
      const reconcile = GroupingBySameAmountButDiffDateWithRemarkAndContactName(
        paymentBankStatementMock,
        paymentTransactionMap,
        i,
        bankReferenceBankId
      );
      if (reconcile.paymentTransactionId > 0 && reconcile.paymentBankStatementId > 0) {
        reconcileList.push(reconcile);
      }
    }
    paymentBankStatementMockList = paymentBankStatementMockList.filter(
      (paymentBankStatement) => paymentBankStatement.isGrouping === false
    );
  }
  return reconcileList;
};

export const ConvertPaymentTransactionListToMapWithRemark = (paymentTransactionList) => {
  const paymentTransactionMap = new Map();
  if (paymentTransactionList && paymentTransactionList.length > 0) {
    for (const paymentTransaction of paymentTransactionList) {
      const bankDetails = GetBankDetailModelFromPaymentTransaction(paymentTransaction);
      const key = GetKeyForReconciliation(paymentTransaction.paymentDate, paymentTransaction.paymentTotal, bankDetails);
      if (paymentTransactionMap.has(key)) {
        const paymentTransactionIdList = paymentTransactionMap.get(key);
        paymentTransactionIdList.push(paymentTransaction.id);
        paymentTransactionMap.set(key, paymentTransactionIdList);
      } else {
        paymentTransactionMap.set(key, [paymentTransaction.id]);
      }
    }
  }
  return paymentTransactionMap;
};
export const GetBankDetailModelFromPaymentTransaction = (paymentTransaction) => {
  return {
    bankaccountname: paymentTransaction.contactAccountName ? paymentTransaction.contactAccountName : "",
    bankaccount: paymentTransaction.contactAccountNumber ? paymentTransaction.contactAccountNumber : "",
    bankname: paymentTransaction.contactBankName ? paymentTransaction.contactBankName : "",
  };
};
export const GetContactNameModelFromPaymentTransaction = (paymentTransaction) => {
  return {
    contactname: paymentTransaction.contactName ? paymentTransaction.contactName : "",
  };
};
export const ConvertPaymentTransactionListToMapWithRemarkRelaxBankAccountName = (paymentTransactionList) => {
  const paymentTransactionMap = new Map();
  if (paymentTransactionList && paymentTransactionList.length > 0) {
    for (const paymentTransaction of paymentTransactionList) {
      const bankDetails = GetBankDetailModelFromPaymentTransaction(paymentTransaction);
      const key = GetKeyForReconciliationRelaxBankAccountName(
        paymentTransaction.paymentDate,
        paymentTransaction.paymentTotal,
        bankDetails
      );

      if (paymentTransactionMap.has(key)) {
        const paymentTransactionIdList = paymentTransactionMap.get(key);
        paymentTransactionIdList.push(paymentTransaction.id);
        paymentTransactionMap.set(key, paymentTransactionIdList);
      } else {
        paymentTransactionMap.set(key, [paymentTransaction.id]);
      }
    }
  }
  return paymentTransactionMap;
};
export const ConvertPaymentTransactionListToMapWithRemarkToContactName = (paymentTransactionList) => {
  const paymentTransactionMap = new Map();
  if (paymentTransactionList && paymentTransactionList.length > 0) {
    for (const paymentTransaction of paymentTransactionList) {
      const contactDetails = GetContactNameModelFromPaymentTransaction(paymentTransaction);
      const key = GetKeyForReconciliationToContactNameForPaymentTransaction(
        paymentTransaction.paymentDate,
        paymentTransaction.paymentTotal,
        contactDetails
      );

      if (paymentTransactionMap.has(key)) {
        const paymentTransactionIdList = paymentTransactionMap.get(key);
        paymentTransactionIdList.push(paymentTransaction.id);
        paymentTransactionMap.set(key, paymentTransactionIdList);
      } else {
        paymentTransactionMap.set(key, [paymentTransaction.id]);
      }
    }
  }
  return paymentTransactionMap;
};

export const ConvertPaymentTransactionListToMapWithRemarkAndContactName = (paymentTransactionList) => {
  const paymentTransactionMap = new Map();
  if (paymentTransactionList && paymentTransactionList.length > 0) {
    for (const paymentTransaction of paymentTransactionList) {
      const contactDetails = GetContactNameModelFromPaymentTransaction(paymentTransaction);
      const bankDetails = GetBankDetailModelFromPaymentTransaction(paymentTransaction);
      const key = GetKeyForReconciliationWithRemarkAndContactNameForPaymentTransaction(
        paymentTransaction.paymentDate,
        paymentTransaction.paymentTotal,
        bankDetails,
        contactDetails
      );

      if (paymentTransactionMap.has(key)) {
        const paymentTransactionIdList = paymentTransactionMap.get(key);
        paymentTransactionIdList.push(paymentTransaction.id);
        paymentTransactionMap.set(key, paymentTransactionIdList);
      } else {
        paymentTransactionMap.set(key, [paymentTransaction.id]);
      }
    }
  }
  return paymentTransactionMap;
};

export const GetKeyForReconciliation = (paymentDate, paymentTotal, bankDetails) => {
  const modifiedBankAccount = `X${String(bankDetails.bankaccount).slice(-4)}`;
  const simplifiedBankAccountName = bankDetails.bankaccountname
    ? removePrefixForBankAccountName(bankDetails.bankaccountname).trim().split(" ")[0]
    : "";

  const modifiedBankName =
    modifiedBankAccount !== null &&
    modifiedBankAccount !== undefined &&
    simplifiedBankAccountName !== null &&
    simplifiedBankAccountName !== undefined
      ? normalizeBankName(bankDetails.bankname)
      : "กสิกรไทย";

  return `${paymentDate ? paymentDate.ToDateJsonString() : ""}:${
    paymentTotal ? paymentTotal.ToNumber() : ""
  }:${modifiedBankName}:${modifiedBankAccount}:${simplifiedBankAccountName}`;
};

export const GetKeyForReconciliationRelaxBankAccountName = (paymentDate, paymentTotal, bankDetails) => {
  const modifiedBankName = normalizeBankName(bankDetails.bankname);

  const modifiedBankAccount = `X${String(bankDetails.bankaccount).slice(-4)}`;

  return `${paymentDate ? paymentDate.ToDateJsonString() : ""}:${
    paymentTotal ? paymentTotal.ToNumber() : ""
  }:${modifiedBankName}:${modifiedBankAccount}`;
};

export const GetKeyForReconciliationToContactNameForPaymentTransaction = (
  paymentDate,
  paymentTotal,
  contactDetails
) => {
  const modifiedContactName = normalizeContactName(contactDetails.contactname)
    ? normalizeContactName(contactDetails.contactname).split(" ")[0]
    : "";
  return `${paymentDate ? paymentDate.ToDateJsonString() : ""}:${
    paymentTotal ? paymentTotal.ToNumber() : ""
  }:${modifiedContactName}`;
};

export const GetKeyForReconciliationToContactName = (paymentDate, paymentTotal, bankDetails) => {
  const simplifiedBankAccountName = bankDetails.bankaccountname ? bankDetails.bankaccountname.trim().split(" ")[0] : "";
  return `${paymentDate ? paymentDate.ToDateJsonString() : ""}:${
    paymentTotal ? paymentTotal.ToNumber() : ""
  }:${simplifiedBankAccountName}`;
};

export const GetKeyForReconciliationWithRemarkAndContactNameForPaymentTransaction = (
  paymentDate,
  paymentTotal,
  bankDetails,
  contactDetails
) => {
  const modifiedContactName = normalizeContactName(contactDetails.contactname)
    ? normalizeContactName(contactDetails.contactname).split(" ")[0]
    : "";

  const modifiedBankAccount = `X${String(bankDetails.bankaccount).slice(-4)}`;

  const simplifiedBankAccountName = bankDetails.bankaccountname
    ? removePrefixForBankAccountName(bankDetails.bankaccountname).trim().split(" ")[0]
    : "";

  const modifiedBankName =
    modifiedBankAccount !== null &&
    modifiedBankAccount !== undefined &&
    simplifiedBankAccountName !== null &&
    simplifiedBankAccountName !== undefined
      ? normalizeBankName(bankDetails.bankname)
      : "กสิกรไทย";

  return `${paymentDate ? paymentDate.ToDateJsonString() : ""}:${
    paymentTotal ? paymentTotal.ToNumber() : ""
  }:${modifiedContactName}:${modifiedBankName}:${modifiedBankAccount}:${simplifiedBankAccountName}`;
};

export const GetKeyForReconciliationWithRemarkAndContactName = (paymentDate, paymentTotal, bankDetails) => {
  const simplifiedBankAccountName = bankDetails.bankaccountname ? bankDetails.bankaccountname.trim().split(" ")[0] : "";

  const modifiedBankAccount = `X${String(bankDetails.bankaccount).slice(-4)}`;

  const modifiedBankName =
    modifiedBankAccount !== null &&
    modifiedBankAccount !== undefined &&
    simplifiedBankAccountName !== null &&
    simplifiedBankAccountName !== undefined
      ? normalizeBankName(bankDetails.bankname)
      : "กสิกรไทย";

  return `${paymentDate ? paymentDate.ToDateJsonString() : ""}:${
    paymentTotal ? paymentTotal.ToNumber() : ""
  }:${simplifiedBankAccountName}:${modifiedBankName}:${modifiedBankAccount}:${simplifiedBankAccountName}`;
};

export const IsSupportedBankForRemark = (bankReferenceBankId) => {
  const supportedBanks = [Enums.BankReferenceType.KBANK];
  if (!bankReferenceBankId || !Array.isArray(supportedBanks)) {
    return false;
  }
  return supportedBanks.includes(bankReferenceBankId);
};

export const IsSupportedBankForRemarkRelaxBankAccountName = (bankReferenceBankId) => {
  const supportedBanks = [Enums.BankReferenceType.SCB];
  if (!bankReferenceBankId || !Array.isArray(supportedBanks)) {
    return false;
  }
  return supportedBanks.includes(bankReferenceBankId);
};

export const normalizeBankName = (bankName) => {
  const bankMappings = {
    เอเอ็นแซด: "ANZ",
    กสิกรไทย: "KBANK",
    กรุงศรีอยุธยา: "BAY",
    กรุงเทพ: "BBL",
    "บีเอ็นพี พารีบาส์": "BNP",
    แห่งอเมริกา: "BOA",
    "แห่งประเทศจีน (ไทย)": "BOC",
    ซีไอเอ็มบีไทย: "CIMB",
    ซิตี้แบงก์: "CITIBANK",
    ดอยซ์แบงก์: "DB",
    เอ็กซิม: "EXIM",
    อาคารสงเคราะห์: "GHBANK",
    ออมสิน: "GSB",
    "เอช เอส บี ซี": "HSBC",
    อิสลามแห่งประเทศไทย: "IBANK",
    ไอซีบีซี: "ICBC",
    อินเดียนโอเวอร์ซีส์: "IOB",
    "เจพีมอร์แกน เชส": "JPMORGAN",
    เกียรตินาคิน: "KK",
    กรุงไทย: "KTB",
    "แลนด์ แอนด์ เฮาส์": "LHBANK",
    มิซูโฮ: "MIZUHO",
    "โอเวอร์ซี-ไชนีส": "OCBC",
    "ซูมิโตโม มิตซุย ทรัสต์": "SMTB",
    "อาร์ เอช บี": "RHB",
    ไทยพาณิชย์: "SCB",
    "สแตนดาร์ดชาร์เตอร์ด (ไทย)": "SCBT",
    "ซูมิโตโม มิตซุย": "SMBC",
    เอชเอ็มอี: "SME",
    ธนชาต: "TCAP",
    ไทยเครดิตเพื่อรายย่อย: "TCR",
    "เมกะ สากลพาณิชย์": "THAIPR",
    ทิสโก้: "TISCO",
    ทหารไทยธนชาต: "TTB",
    ยูโอบี: "UOB",
    อื่นๆ: "Other",
    None: "None",
  };

  const cleanName = bankName.replace(/^ธ\.|^ธนาคาร\s*/i, "").trim();

  return bankMappings[cleanName] || cleanName;
};

function normalizeContactName(inputString) {
  if (typeof inputString !== "string" || !inputString.trim()) {
    return "";
  }
  const words = inputString.split(" ");
  return words.slice(1).join(" ");
}

function removePrefixForBankAccountName(text) {
  if (!text) return "";

  const prefixes = [
    "บริษัท ",
    "ห้างหุ้นส่วนจำกัด ",
    "มูลนิธิ ",
    "สมาคม ",
    "โรงเรียน ",
    "วัด ",
    "นาย ",
    "นางสาว",
    "นาง ",
    "น.ส. ",
  ];

  for (const prefix of prefixes) {
    if (text.startsWith(prefix)) {
      return text.substring(prefix.length);
    }
  }

  return text;
}

export function GetReconcileTableDefaultDate(isFormatDate = true) {
  /* default date is first day of last month to last day of this month */

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  let fromDate = new Date(currentYear, currentMonth - 1, 1);
  let toDate = new Date(currentYear, currentMonth + 1, 0);

  if (isFormatDate) {
    fromDate.ToDateJsonString();
    toDate.ToDateJsonString();
  }

  return { fromDate, toDate };
}

export function GetReconcileTableParameters(queryParams) {
  const { fromDate: defaultFromDate, toDate: defaultToDate } = GetReconcileTableDefaultDate();
  const defaultSortBy = Enums.TableReconcileSortBy.Date;
  const defaultSortingType = Enums.TableSorting.ASC;
  const defaultPaymentInOutFlowType = Enums.PaymentInOutFlowType.None;

  const fromDate = queryParams.fromDate ? queryParams.fromDate.ToDateJsonString() : defaultFromDate;
  const toDate = queryParams.toDate ? queryParams.toDate.ToDateJsonString() : defaultToDate;
  const fromNetAmount = queryParams.fromNetAmount ? queryParams.fromNetAmount.FormatMoney() : null;
  const toNetAmount = queryParams.toNetAmount ? queryParams.toNetAmount.FormatMoney() : null;
  const inputSearch = queryParams.inputSearch ? queryParams.inputSearch : "";
  const pageNo = queryParams.pageNo ? queryParams.pageNo : 1;
  const pageSize = queryParams.pageSize ? queryParams.pageSize : 10;
  const sortBy = queryParams.sortBy ? queryParams.sortBy : defaultSortBy;
  const sortType = queryParams.sortType !== undefined ? queryParams.sortType : defaultSortingType;
  const paymentInOutFlowType =
    queryParams.paymentInOutFlowType !== undefined ? queryParams.paymentInOutFlowType : defaultPaymentInOutFlowType;

  return {
    fromDate,
    toDate,
    fromNetAmount,
    toNetAmount,
    inputSearch,
    pageNo,
    pageSize,
    sortBy,
    sortType,
    paymentInOutFlowType,
  };
}

export const SuggestContactByRemark = (contactList, extractedRemark) => {
  if (!Array.isArray(contactList) || contactList.length === 0) {
    return null;
  }
  if (contactList.length === 1) {
    return contactList[0];
  }

  const normalizeFields = (contact) => {
    const processedContactBankName = normalizeBankName(contact?.contactBankName || "") || "Blank";
    const processedExtractedBankName = normalizeBankName(extractedRemark?.bankname || "") || "Blank";

    const processedContactAccountNumber = contact?.contactAccountNumber
      ? `X${String(contact.contactAccountNumber).slice(-4)}`
      : "Blank";
    const processedExtractedAccountNumber = extractedRemark?.bankaccount || "Blank";

    const processedContactAccountName = contact?.contactAccountName
      ? removePrefixForBankAccountName(contact.contactAccountName).trim().split(" ")[0]
      : "Blank";
    const processedExtractedAccountName = extractedRemark?.bankaccountname
      ? removePrefixForBankAccountName(extractedRemark.bankaccountname).trim().split(" ")[0]
      : "Blank";

    return {
      processedContactBankName,
      processedExtractedBankName,
      processedContactAccountNumber,
      processedExtractedAccountNumber,
      processedContactAccountName,
      processedExtractedAccountName,
    };
  };

  // 1) Strict match on bank + account # + name
  let suggestion = contactList.find((contact) => {
    if (!contact) return false;
    const f = normalizeFields(contact);

    return (
      f.processedContactBankName === f.processedExtractedBankName &&
      f.processedContactAccountNumber === f.processedExtractedAccountNumber &&
      f.processedContactAccountName === f.processedExtractedAccountName
    );
  });

  if (!suggestion) {
    suggestion = contactList.find((contact) => {
      if (!contact) return false;
      const { processedContactAccountName, processedExtractedAccountName } = normalizeFields(contact);

      return processedContactAccountName === processedExtractedAccountName;
    });
  }

  if (!suggestion) {
    suggestion = contactList.find((contact) => {
      if (!contact) return false;
      const {
        processedContactAccountNumber,
        processedExtractedAccountNumber,
        processedContactBankName,
        processedExtractedBankName,
      } = normalizeFields(contact);

      return (
        processedContactAccountNumber === processedExtractedAccountNumber &&
        processedContactBankName === processedExtractedBankName
      );
    });
  }

  return suggestion || null;
};
export const IsSupportedBankForSuggestContactFromRemark = (bankType) => {
  const supportedBanks = [Enums.BankReferenceType.KBANK, Enums.BankReferenceType.SCB];
  if (!bankname || !Array.isArray(supportedBanks)) {
    return false;
  }
  return supportedBanks.includes(bankType);
};
